import { useT } from "../lang/LangContext";
import { SectionHeading } from "./SectionHeading";

type Item = string | [string, string];

interface Group {
  titleEn: string;
  titlePt: string;
  inverted?: boolean;
  items: Item[];
}

const GROUPS: Group[] = [
  {
    titleEn: "AI & BACKEND",
    titlePt: "IA & BACKEND",
    inverted: true,
    items: [
      "Python",
      "LangGraph",
      "LLM integrations",
      "Node.js",
      "Java",
      "REST APIs",
    ],
  },
  {
    titleEn: "FRONTEND",
    titlePt: "FRONTEND",
    items: ["TypeScript", "JavaScript", "React", "Next.js", "Tailwind CSS"],
  },
  {
    titleEn: "CLOUD & DELIVERY",
    titlePt: "NUVEM & ENTREGA",
    items: [
      "AWS",
      "Azure",
      "Docker",
      "Kubernetes",
      "CI/CD",
      ["Observability", "Observabilidade"],
    ],
  },
  {
    titleEn: "DATA & QUALITY",
    titlePt: "DADOS & QUALIDADE",
    items: [
      "PostgreSQL",
      "SQL / NoSQL",
      ["Automated testing", "Testes automatizados"],
      "Jest",
      "Selenium",
    ],
  },
];

export function Toolbox() {
  const t = useT();

  return (
    <section
      id="stack"
      style={{ maxWidth: 1180, margin: "0 auto", padding: "36px 20px 64px" }}
    >
      <SectionHeading index="04">{t("Toolbox", "Ferramentas")}</SectionHeading>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit,minmax(250px,1fr))",
          gap: 18,
        }}
      >
        {GROUPS.map((group) => (
          <div
            key={group.titleEn}
            style={{
              border: "3px solid var(--fg)",
              background: group.inverted ? "var(--fg)" : "transparent",
              color: group.inverted ? "var(--bg)" : "var(--fg)",
              padding: 20,
            }}
          >
            <div
              style={{
                fontFamily: "'Archivo Black',sans-serif",
                fontSize: 14,
                letterSpacing: "0.08em",
                marginBottom: 12,
                color: group.inverted ? undefined : "var(--accent)",
              }}
            >
              {t(group.titleEn, group.titlePt)}
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
              {group.items.map((item) => {
                const label = Array.isArray(item) ? t(item[0], item[1]) : item;
                return (
                  <span
                    key={Array.isArray(item) ? item[0] : item}
                    style={{
                      fontSize: 12,
                      border: `2px solid ${
                        group.inverted ? "var(--bg)" : "var(--fg)"
                      }`,
                      padding: "5px 9px",
                    }}
                  >
                    {label}
                  </span>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
